import { useDocumentTitle } from '@hooks/use-document-title';
import { useTranslations } from '@i18n/use-translations';
import { useLocation } from 'react-router';

const VALID_PATHNAMES = [
  '/',
  '/dashboard',
  '/users',
  '/customers',
  '/carriers',
  '/devices',
  '/profiles',
  '/settings',
  '/alerts',
  '/logs',
] as const;

type Pathname = (typeof VALID_PATHNAMES)[number];

export const useSetPageTitle = () => {
  const { pathname } = useLocation();
  const t = useTranslations('titles');

  const isValidAppPath = (path: string): path is Pathname => {
    return VALID_PATHNAMES.includes(path as Pathname);
  };

  let title: string;
  if (isValidAppPath(pathname)) {
    title = t(pathname);
  } else {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn(`Page title not translated for pathname: ${pathname}`);
    }
    title = t('fallback');
  }

  useDocumentTitle(title);
};
